import { motion } from "framer-motion";
import { MaskLines, Eyebrow } from "@/components/site/Motion";

export const PageHero = ({ eyebrow, lines, sub, img }) => (
  <section className="relative overflow-hidden bg-[#050B1F] px-4 pb-20 pt-36 text-white sm:px-6 lg:px-12 lg:pb-28 lg:pt-44 grain">
    <div className="absolute -left-40 top-20 h-[28rem] w-[28rem] rounded-full bg-emerald-500/20 blur-3xl" />
    <div className="relative mx-auto grid max-w-7xl items-end gap-12 lg:grid-cols-12">
      <div className="lg:col-span-7">
        <Eyebrow light>{eyebrow}</Eyebrow>
        <h1 className="mt-6 font-display text-5xl font-extrabold leading-[0.95] tracking-tight sm:text-6xl lg:text-7xl">
          <MaskLines lines={lines.map((l, i) => (i === lines.length - 1 ? <span className="text-lime-400">{l}</span> : l))} />
        </h1>
        <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.6, duration: 0.8 }} className="mt-8 max-w-xl text-base text-emerald-100/85 md:text-lg">{sub}</motion.p>
      </div>
      {img && (
        <motion.div initial={{ clipPath: "inset(100% 0 0 0 round 2rem)" }} animate={{ clipPath: "inset(0% 0 0 0 round 2rem)" }} transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1], delay: 0.3 }} className="lg:col-span-5">
          <img src={img} alt="" className="aspect-[4/3] w-full rounded-[2rem] object-cover" />
        </motion.div>
      )}
    </div>
  </section>
);
